<template>
  <div class="tab">
    <div>
      <span @click="returnFun()">＜返回</span>
      <h4>童伴计划项目</h4>
      <p>由“中国扶贫基金会”、“中国公益研究院”联合“共青团四川省委”启动的“童伴计划”项目，探索用新的模式为农村留守儿童提供服务，关注留守儿童在各方面的需要。在项目推进过程中除了为留守儿童提供物质、政策等方面的支持，其身心健康成长亦是项目关注的重要方面。</p>
      <!-- <p>自2017年起，“童伴计划”与北京师范大学心理学部林丹华教授团队合作，增加了心理服务开发模块，旨在通过系列培训，促进儿童主任（童伴妈妈，以下均称为“童伴妈妈”）对项目区儿童开展不同类型、不同层面的心理支持。首次培训于2017年3月举行，为100位童伴妈妈开展关于儿童心理发展规律、留守儿童心理特点相关的集中培训。同时，于2018年初编制完成《基层儿童心理支持服务工作指南》（以下简称《指南》），并对童伴妈妈开展了系列全面深度的心理弹性干预培训。</p>
      <p>迄今为止，林丹华教授团队已为四川、贵州、江西、青海、云南、山西六个省份、34个区县、375个村落的688个（人次）童伴妈妈开展了心理弹性干预培训，收到了很好的效果，达到了广泛、深入地开展农村基层社区留守儿童关爱工作人员培训之目的！</p> -->
      <p>在过去五年间，“童伴计划”与北京师范大学心理学部林丹华教授团队合作，增加了心理服务开发模块，旨在通过系列培训，促进儿童主任（童伴妈妈，以下均称为“童伴妈妈”）对项目区儿童开展不同类型、不同层面的心理支持。林丹华教授于2017年3月为100位童伴妈妈开展关于儿童心理发展规律、留守儿童心理特点相关的集中培训。同时，于2018年初编制完成《基层儿童心理支持服务工作指南》（以下简称《指南》），并对童伴妈妈开展了系列全面深度的心理弹性干预培训。</p>
      <p>在长达五年的时间里，林丹华教授多次亲自带领团队到四川省和贵州省对“童伴妈妈”开展心理关怀工作能力提升培训，受益人群惠及四川、贵州等五个省的五十多个区/县的七百余村，覆盖约三十万名儿童。借助童伴妈妈项目，林丹华教授打通了将“心理关怀工作以及系列培训课程和相关资源”送到留守儿童及其家庭、农村社区工作者身边的“最后一公里”，逐步摸索形成了一套可推广、可复制、有实效的农村社区工作者心理关怀能力提升培训模式，为当地培养了一支具有开展心理关怀工作基本能力的童伴妈妈队伍。</p>
      <img src="../../assets/list3.png" alt />
      <span>图：林丹华老师为童伴妈妈开展《留守儿童心理健康教育》培训</span>
      <img src="../../assets/list3_1.png" alt />
      <span>图：组织童伴妈妈开展《心理健康工作坊-让爱流动》活动</span>
      <img src="../../assets/list3_2.png" alt />
      <span>图：为贵州童伴妈妈开展心理弹性团体活动培训</span>
      <img src="../../assets/list3_3.png" alt />
      <span>图：2018年12月童伴妈妈项目培训结业留念照</span>
      
    </div>
  </div>
</template>
<script>
export default {
  name: "list3",
  data() {
    return {};
  },
  props: ["listOrCon"],
  methods:{
    returnFun(){
      this.$emit("returnPage")
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab > div {
  padding: 0;
}
.tab > div > span:first-child{
  cursor: pointer;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 5px;
  color: #7ecef4;
  border: solid 1px #7ecef4
}
.tab > div > h4 {
  text-align: center;
  font-size: 24px;
}
.tab > div > h5 {
  text-align: center;
  margin: 30px 0;
  font-size: 20px;
}
.tab > div > img {
  margin: 20px 0;
}
.tab > div > span {
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/psychological/list3.vue